import React from 'react';
import { Button, Icon, useDisclosure } from '@wegroup/design-system';
import { InsurancePolicyClause } from '../../../../../../../types/AdvisoryReport';
import { useTranslation } from 'react-i18next';
import InsurancePolicyClausesModal from './InsurancePolicyClausesModal';

interface Props {
  clauses?: InsurancePolicyClause[];
}

const InsurancePolicyClausesButton: React.FC<Props> = ({ clauses = [] }) => {
  const { t } = useTranslation();
  const { isOpen, onClose, onOpen } = useDisclosure();

  return (
    <>
      {/* To prevent it from rendering if not open (Because insurancepolicies have weak performance) */}
      {isOpen && (
        <InsurancePolicyClausesModal
          isOpen={true}
          onClose={onClose}
          clauses={clauses}
        />
      )}
      <Button
        leftIcon={<Icon name="IconClaimsFilled" />}
        size="sm"
        variant="white"
        w="100%"
        onClick={onOpen}
      >
        {t('INSURANCE-POLICIES_CLAUSES_BUTTON')} ({clauses.length})
      </Button>
    </>
  );
};

export default InsurancePolicyClausesButton;
